import { useParams } from '@rocketlane/rocket-router';
import { PageType } from 'api/page-template/types';
import { useEffect } from 'react';
import { useEmailPagesRouteNavigations } from 'components/organisms/email-pages/route-navigations';
import { DocumentPage } from './document/page';

export type EmailPagesPermissions = {
  canReadEmailPages: boolean;
  canWriteEmailPages?: boolean;
  canDeleteEmailPages: boolean;
  canReadEmailPageTemplates: boolean;
  canCreateEmailPageTemplates: boolean;
  canWriteEmailPageTemplates: boolean;
  canDeleteEmailPageTemplates: boolean;
  canWriteEmailIntelligenceSettings?: boolean;
};

interface EmailPageDocumentProps {
  projectId?: number;
  documentId?: number;
  accountId?: number;
  emailPermissions?: EmailPagesPermissions;
  isModuleFed?: boolean;
}

export const EmailPageDocument = ({
  projectId,
  documentId: documentIdProp,
  accountId: accountIdProp,
  emailPermissions,
  isModuleFed = true,
}: EmailPageDocumentProps = {}) => {
  const params = useParams();
  const documentId = documentIdProp ?? Number(params.documentId);
  const accountId = accountIdProp ?? Number(params.accountId);
  const { navigateToEmail, navigateToList } =
    useEmailPagesRouteNavigations(projectId);

  // In module federation mode, use projectId as companyId for navigation
  // Otherwise, use accountId
  const companyIdForNavigation = projectId ?? accountId;

  const shouldBlock =
    isModuleFed &&
    emailPermissions != null &&
    !emailPermissions.canReadEmailPages;

  useEffect(() => {
    if (shouldBlock) {
      navigateToList(companyIdForNavigation);
    }
  }, [shouldBlock, companyIdForNavigation, navigateToList]);

  if (shouldBlock) {
    return null;
  }

  return (
    <DocumentPage
      documentId={documentId}
      onBack={() => navigateToEmail(companyIdForNavigation, documentId)}
      pageType={PageType.Email}
    />
  );
};
